/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import { HandHeart } from '@strapi/icons';
const PluginIcon = () => /*#__PURE__*/React.createElement(HandHeart, null);
export default PluginIcon;